export default __webpack_public_path__ + "static/media/icon-prototype-testing.22e9c6ff.svg";